
import { Vue, prop, Options } from "vue-class-component";
class Props {
  items = prop({ default: [] });
}

export interface NavbarItem {
  /**
   * The title of the item to display in the navbar.
   */
  title: string;

  /**
   * To which route this link will lead to.
   *
   * @remarks
   * If a string is given, the link will be treated as is. If an object with name
   * is given, the link will route to the namedRoute of that name.
   */
  to: string | { name: string };

  /**
   * Determines if the item is considered active.
   *
   * @remarks
   * Parent navbar can decide to apply a different style with this value.
   */
  isActive?: boolean;
}
@Options({ name: "Navbar" })
export default class Navbar extends Vue.with(Props) {
  /**
   * Determines if the burger should be shown.
   */
  isBurgerActive = false;

  /**
   * Toggles navbar display status when burger is clicked.
   */
  onBurgerClick(): void {
    this.isBurgerActive = !this.isBurgerActive;
  }
}
